interface CheckIconComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  onClick?: (value: any) => void;
  style?: React.CSSProperties;

}

const CheckIconSVGComponent = ({ primaryColor, secondaryColor, onClick, style }: CheckIconComponentProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
<path d="M5.08301 12L10.083 17L20.083 7" stroke="#12B76A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

export default CheckIconSVGComponent;
